module.exports = __webpack_public_path__ + "static/img/introduction-welcome-170100548.600ae69.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduction/introduction-welcome-170100548.jpg
// module id = dqTh
// module chunks = 0